function bookMoriPresentmentRate(shopCurrency, currency) {
  if (currency === shopCurrency) return 1;
  const rate = Number(window.Shopify?.currency?.rate);
  return Number.isFinite(rate) && rate > 0 ? rate : null;
}

function bookMoriShippingGoal(element) {
  if (!element || element.dataset.goalType === 'quantity') return null;
  const rate = bookMoriPresentmentRate(element.dataset.shopCurrency, element.dataset.currency);
  const base = Number(element.dataset.goal);
  if (rate === null || !Number.isFinite(base) || base <= 0) return null;
  return Math.ceil(base * rate - 0.000001);
}

class BookMoriMarketProgress extends HTMLElement {
  connectedCallback() {
    queueMicrotask(() => this.update());
  }

  update() {
    this.hidden = this.dataset.physicalCart !== 'true';
    if (this.hidden || this.dataset.goalType === 'quantity') return;
    const goal = bookMoriShippingGoal(this);
    if (goal === null) {
      this.hidden = true;
      return;
    }
    const subtotal = Number(this.dataset.subtotal) || 0;
    const text = this.querySelector('.cart-progress__text');
    const fill = this.querySelector('.cart-progress__bar__progress');
    const complete = subtotal >= goal;
    if (text) {
      if (complete) {
        text.innerHTML = this.dataset.successMessage;
      } else {
        const difference = formatMoney(goal - subtotal, this.dataset.moneyFormat, true);
        text.innerHTML = this.dataset.progressMessage.replace('[amount]', '<span>' + difference + '</span>');
      }
    }
    if (fill) fill.style.width = Math.min(100, Math.max(0, subtotal / goal * 100)) + '%';
    this.dataset.goalReached = String(complete);
    this.dataset.presentmentGoal = String(goal);
  }
}

class BookMoriMarketGifts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.calendar !== 'true') return;
    queueMicrotask(() => {
      if (!this.isConnected) return;
      this.breaks = document.getElementById('quantity-breaks-' + this.dataset.section);
      this.updateShipping = this.update.bind(this);
      this.breaks?.addEventListener('change', this.updateShipping);
      this.update();
    });
  }

  disconnectedCallback() {
    this.breaks?.removeEventListener('change', this.updateShipping);
  }

  update() {
    const progress = document.querySelector('bm-market-progress[data-goal-type="subtotal"]');
    const goal = bookMoriShippingGoal(progress);
    const gift = this.querySelector('[data-shipping-gift="true"]');
    const nativeGifts = this.querySelector('quantity-gifts');
    if (goal === null || !gift || !this.breaks?.offerPrices || !nativeGifts) return;
    const offers = Array.from(this.breaks.querySelectorAll('.quantity-break')).map(label => {
      const key = label.dataset.input.replace('input_', 'offer_');
      return {quantity: Number(label.dataset.quantity), price: this.breaks.offerPrices[key]?.price};
    }).filter(offer => Number.isFinite(offer.price)).sort((a, b) => a.quantity - b.quantity);
    const minimumQuantity = Math.max(2, Number(gift.dataset.minimumQuantity) || 2);
    const eligible = offers.find(offer => offer.quantity >= minimumQuantity && offer.price >= goal);
    if (!eligible) return;
    gift.dataset.quantity = String(eligible.quantity);
    const key = {1: 'thresholdOne', 2: 'thresholdTwo', 3: 'thresholdThree'}[eligible.quantity];
    const label = gift.querySelector('.quantity-gift__lock__top');
    if (key && label) label.innerHTML = gift.dataset[key];
    const selected = this.breaks.querySelector('input[name="quantity"]:checked');
    nativeGifts.unlockGifts(Number(selected?.value) || 1);
  }
}

if (!customElements.get('bm-market-progress')) customElements.define('bm-market-progress', BookMoriMarketProgress);
if (!customElements.get('bm-market-gifts')) customElements.define('bm-market-gifts', BookMoriMarketGifts);

